import {ShopDataService} from '@webu/data';
import {Component, Input, OnInit} from '@angular/core';
import {LinkPipe, buildTrackingString} from '@ox/utils';
import {CtaType, PaymentMethodDetails, pageTypes} from '@ox/typings';
import {TrackingUrlService} from '../../../services/tracking/tracking-url.service';

@Component({
  selector: 'webu-preferred-payment-method',
  templateUrl: './preferred-payment-method.component.html'
})
export class PreferredPaymentMethodComponent implements OnInit {
  
  @Input() paymentMethod : PaymentMethodDetails;
  paymentLabel?: string;
  endingIn?: string;
  editLabel?: string;
  navigateToPaymentMethodPage = this.trackingUrlService.navigateToPaymentMethodPage;
  //Tracking imports
  trackingString = (cta: CtaType, args: string[]) => buildTrackingString(pageTypes.myPlans, cta, args);
  @Input() parentPlanName = '';

  constructor(
    private shopDataService : ShopDataService,
    private linkPipe: LinkPipe,
    private trackingUrlService: TrackingUrlService
  ) {}

  ngOnInit(){
    this.setText();
  }

  setText(): void {
    this.paymentLabel = this.shopDataService.getGenericCopy('myplans.payment.method.label');
    this.editLabel = this.shopDataService.getGenericCopy('myplans.edit');

    const paymentTypeCopyKeys: Record<string, string> = {
      'PAYPAL': 'myplans.payment.method.paypal',
      'ACH': 'myplans.payment.method.ach',
      'CC': 'myplans.payment.method.cc'
    };
    const endingInCopyKey = paymentTypeCopyKeys[this.paymentMethod?.paymentType] || paymentTypeCopyKeys['CC'];
    this.endingIn = this.shopDataService.getGenericCopy(
      endingInCopyKey,
      {paymentValue: this.paymentMethod?.paymentValue}
    );
  }

  getPaymentMethodImageLink(): string {
    const type = this.paymentMethod.paymentType === 'MASTERCARD' ? 'master-card' : this.paymentMethod.paymentType.toLowerCase();
    return this.linkPipe.transform('/content/dam/gmownercenter/global/resources/icons/symbol-defs.svg#icon-pay-' + type);
  }
}
